import React from 'react';

/** Presenta los valores de las métricas en la posición activa del detalle. */
export function DetailHoverSummary({
  values,
  metrics,
  alarm,
  note
}) {
  if (values.hDisp === 'none') return null;
  const cursorOnRight = Number.parseFloat(values.hx) >= 50;
  const tooltipLeft = cursorOnRight ? 0 : 'calc(100% - 13.541667vw)';
  return <div role="status" aria-label={`Detalle al cursor a las ${values.hTime}`} style={{
    position: 'absolute',
    zIndex: 1000,
    top: 0,
    left: tooltipLeft,
    display: 'flex',
    flexDirection: 'column',
    gap: "0.555556vh",
    width: "13.541667vw",
    boxSizing: 'border-box',
    padding: "0.925926vh 1.018519vh",
    pointerEvents: 'none',
    overflow: 'visible',
    background: 'rgba(5,15,30,0.97)',
    border: "0.092593vh solid rgba(228,233,240,0.16)",
    borderRadius: "0.648148vh",
    boxShadow: "0 0.740741vh 2.037037vh rgba(0,0,0,0.34)"
  }}>
      <div style={{
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      gap: "0.925926vh",
      paddingBottom: "0.555556vh",
      borderBottom: "0.092593vh solid rgba(135,147,166,0.22)"
    }}>
        <span style={{
        fontSize: "1.018519vh",
        color: '#8793a6',
        textTransform: 'uppercase',
        letterSpacing: '.05em'
      }}>Hora</span>
        <strong style={{
        font: "700 1.481481vh 'IBM Plex Mono',monospace",
        color: 'oklch(0.8 0.13 85)'
      }}>{values.hTime}</strong>
      </div>
      {metrics.map(metric => <div key={metric.label} title={`${metric.label} ${metric.value}${metric.unit ? ` ${metric.unit}` : ''}`} style={{
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr) auto',
      alignItems: 'baseline',
      gap: "0.740741vh",
      minHeight: "2.037037vh"
    }}>
          <span style={{
        color: '#b8c1ce',
        fontSize: "1.111111vh"
      }}>{metric.label}</span>
          <span style={{
        display: 'inline-flex',
        alignItems: 'baseline',
        gap: "0.37037vh",
        minWidth: 0
      }}>
            <strong style={{
          font: "700 1.388889vh 'IBM Plex Mono',monospace",
          color: metric.color
        }}>{metric.value}</strong>
            {metric.unit && <small style={{
          fontSize: "0.925926vh",
          color: '#7f8ca0'
        }}>{metric.unit}</small>}
          </span>
        </div>)}
      {alarm && <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: "0.37037vh",
      marginTop: "0.277778vh",
      paddingTop: "0.740741vh",
      borderTop: "0.092593vh solid rgba(135,147,166,0.24)"
    }}>
          <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: "0.740741vh",
        marginBottom: "0.185185vh"
      }}>
            <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: "0.648148vh",
          color: '#e4e9f0',
          fontSize: "1.111111vh",
          fontWeight: 600
        }}>
              <i style={{
            width: "0.46875vw",
            height: "0.833333vh",
            flex: 'none',
            borderRadius: '50%',
            background: alarm.fill,
            border: `0.185185vh solid ${alarm.c}`
          }} />
              Alarmas
            </span>
            <strong style={{
          font: "700 1.111111vh 'IBM Plex Sans',sans-serif",
          color: alarm.c
        }}>{alarm.badge}</strong>
          </div>
          {(alarm.rows || []).map((row, index) => <div key={`${row.l}-${index}`} style={{
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr) auto',
        alignItems: 'baseline',
        gap: "0.740741vh",
        minHeight: "1.851852vh"
      }}>
              <span title={row.l} style={{
          color: '#8793a6',
          fontSize: "1.018519vh",
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>{row.l}</span>
              <strong style={{
          font: "700 1.203704vh 'IBM Plex Mono',monospace",
          color: row.c || '#e4e9f0',
          whiteSpace: 'nowrap'
        }}>{row.v}</strong>
            </div>)}
        </div>}
      {note && <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: "0.37037vh",
      marginTop: "0.277778vh",
      paddingTop: "0.740741vh",
      borderTop: "0.092593vh solid rgba(168,140,240,0.45)"
    }}>
          <strong style={{ color: '#a88cf0', fontSize: "1.111111vh" }}>Notas</strong>
          <span style={{ color: '#d7d1e8', fontSize: "1.018519vh", whiteSpace: 'pre-wrap' }}>{note.text}</span>
        </div>}
    </div>;
}

/** Presenta el intervalo de alimentación asociado al cursor. */
export function FeedingTimeTooltip({
  children,
  content,
  align = 'center'
}) {
  const [open, setOpen] = React.useState(false);
  const rows = String(content || '').split(' | ').filter(Boolean).map(part => {
    const pieces = part.split(' · ');
    const head = pieces.shift() || '';
    const split = head.indexOf(': ');
    return {
      label: split >= 0 ? head.slice(0, split) : 'Horario',
      time: split >= 0 ? head.slice(split + 2) : head,
      day: pieces.shift() || '',
      cage: pieces.join(' · ')
    };
  });
  const translate = align === 'left' ? '0' : align === 'right' ? '-100%' : '-50%';
  const left = align === 'left' ? '0' : align === 'right' ? '100%' : '50%';
  return <span onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} onFocus={() => setOpen(true)} onBlur={() => setOpen(false)} tabIndex={0} style={{
    position: 'relative',
    display: 'inline-flex',
    minWidth: 0,
    outline: 'none'
  }}>
      {children}
      {open && rows.length > 0 && <span role="tooltip" style={{
      position: 'absolute',
      left,
      bottom: "calc(100% + 0.925926vh)",
      transform: 'translateX(' + translate + ')',
      zIndex: 120,
      width: rows.length > 1 ? "15.625vw" : "13.541667vw",
      padding: "0.925926vh 1.111111vh",
      borderRadius: "0.740741vh",
      border: "0.092593vh solid rgba(46,179,238,0.36)",
      background: 'linear-gradient(180deg,rgba(12,28,48,0.99),rgba(5,14,28,0.99))',
      boxShadow: "0 1.111111vh 2.777778vh rgba(0,0,0,0.48)",
      pointerEvents: 'none',
      boxSizing: 'border-box'
    }}>
          <span style={{
        display: 'block',
        marginBottom: "0.648148vh",
        color: '#e4e9f0',
        fontSize: "1.111111vh",
        fontWeight: 700
      }}>
            Origen del horario
          </span>
          {rows.map((row, index) => <span key={row.label + '-' + index} style={{
        display: 'block',
        padding: index ? "0.740741vh 0 0" : '0',
        marginTop: index ? "0.740741vh" : '0',
        borderTop: index ? "0.092593vh solid rgba(135,147,166,0.18)" : '0'
      }}>
              <span style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: "0.925926vh",
          marginBottom: "0.648148vh"
        }}>
                <span style={{
            color: '#8793a6',
            fontSize: "0.925926vh",
            fontWeight: 700,
            letterSpacing: '.06em',
            textTransform: 'uppercase'
          }}>{row.label}</span>
                {row.cage && <strong style={{
            maxWidth: '45%',
            color: '#b8c1ce',
            font: "700 1.018519vh 'IBM Plex Mono',monospace",
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>{row.cage}</strong>}
              </span>
              <span style={{
          display: 'flex',
          alignItems: 'center',
          gap: "0.833333vh",
          minWidth: 0
        }}>
                <strong style={{
            flex: 'none',
            color: 'oklch(0.8 0.14 50)',
            font: "700 1.388889vh 'IBM Plex Mono',monospace"
          }}>{row.time}</strong>
                <span style={{
            width: "0.052083vw",
            height: "2.037037vh",
            flex: 'none',
            background: 'rgba(135,147,166,0.24)'
          }} />
                <span style={{
            color: '#d5dbe5',
            font: "1.111111vh 'IBM Plex Mono',monospace",
            whiteSpace: 'nowrap'
          }}>{row.day}</span>
              </span>
            </span>)}
          <span style={{
        position: 'absolute',
        left: align === 'left' ? "0.9375vw" : align === 'right' ? 'auto' : '50%',
        right: align === 'right' ? "0.9375vw" : 'auto',
        bottom: "-0.462963vh",
        width: "0.46875vw",
        height: "0.833333vh",
        transform: align === 'center' ? 'translateX(-50%) rotate(45deg)' : 'rotate(45deg)',
        background: 'rgb(5,14,28)',
        borderRight: "0.052083vw solid rgba(46,179,238,0.36)",
        borderBottom: "0.092593vh solid rgba(46,179,238,0.36)"
      }} />
        </span>}
    </span>;
}
